import { ValidationIcon_default } from "./chunk-LZGR2HFH.js";
import { ValidationMessage_default } from "./chunk-ESL73LRM.js";
import { Icon_default } from "./chunk-3BD6RCWY.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Listbox/Listbox.Option.tsx
import React from "react";
import clsx from "clsx";
import { Listbox as HeadlessListbox } from "@headlessui/react";
var LISTBOX_OPTION_CLASSNAME_MAP = {};
var ListboxOption = _a => {
  var _b = _a,
    {
      children,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["children", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */React.createElement(HeadlessListbox.Option, __spreadValues({
    className: clsx("pd-listbox-option", className)
  }, rest), _ref => {
    let {
      selected
    } = _ref;
    return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
      className: "pd-listbox-option__content"
    }, selected && /* @__PURE__ */React.createElement(Icon_default, {
      icon: "check",
      className: "pd-text-primary-500"
    }), children), validation && /* @__PURE__ */React.createElement("div", {
      className: "pd-list-box-option__validation"
    }, /* @__PURE__ */React.createElement(ValidationIcon_default, {
      variant: validation,
      className: "pd-list-box-option__validation-icon"
    }), /* @__PURE__ */React.createElement(ValidationMessage_default, {
      as: "span",
      variant: validation,
      className: "pd-list-box-option__validation-message"
    }, validationMessage)));
  });
};
var Listbox_Option_default = ListboxOption;
export { LISTBOX_OPTION_CLASSNAME_MAP, Listbox_Option_default };